import MembershipBillingDetails from '@/screens/join-premium/MembershipBillingDetails'

export default function () {
  return <MembershipBillingDetails />
}
